/**
 * Created new sx record of styles properties.
 */

import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const SessionErrorDialogSx: Record<string, SxProps<Theme>> = {
	dialog: {
		borderRadius: '0',
		'.MuiPaper-root': {
			maxWidth: {
				sm: '600px',
			},
			width: {
				sm: '600px',
				md: 'calc(90vw - 20px)',
				lg: 'calc(90vw - 20px)',
			},
		},
	},
	title: {
		p: '10px',
		display: 'flex',
		justifyContent: 'center',
	},
	titleText: {
		alignSelf: 'center',
		fontWeight: OpenSansFontWeights.light,
		color: 'grey.500',
	},
	closeIcon: {
		position: 'absolute',
		right: '10px',
		color: 'grey.100',
		cursor: 'pointer',
		'&:hover': {
			color: 'primary.main',
		},
		fontSize: '20px',
	},
	content: {
		maxWidth: {
			sm: '600px',
			md: '100%',
			lg: '100%',
		},
		minWidth: '288px',
		maxHeight: '90%',
		minHeight: '100px',
	},
	dialogAction: {
		display: 'flex',
		flexDirection: 'column',
		px: 0,
		pb: 0,
		button: {
			width: '100%',
		},
		'.MuiButton-text': {
			margin: 0,
			mt: 1,
			color: 'secondary.main',
			fontWeight: 'OpenSansFontWeights.regular',
		},
		'.MuiButton-text:hover': {
			textDecoration: 'underline',
			backgroundColor: 'transparent',
			color: 'secondary.main',
		},
	},
	switchLabel: {
		'& .MuiFormControlLabel-label': {
			fontWeight: OpenSansFontWeights.regular,
			color: 'grey.500',
			fontSize: '12px',
		},
	},
	switchSubText: {
		display: 'block',
		color: 'grey.200',
	},
	submitButton: {
		minHeight: '40px',
	},
};
